// extracted by mini-css-extract-plugin
export default {"button":"button1_button__T8H26","circle":"button1_circle__qFkBl","icon":"button1_icon__z0eiz","arrow":"button1_arrow__NMzcz","button-text":"button1_button-text__1GsRh"};